module.exports = __webpack_public_path__ + "img/34.f2f941f2.png";